module.exports = __webpack_public_path__ + "img/index3.76624d29.png";